export default "__VITE_ASSET__xDM6uPpj__"